import {
  DesignTokenSizeEnum,
  styled,
} from '@volkswagen-onehub/components-core';
import { convertBreakpointsToMediaQueries } from '@/modules/utils/themeUtils';

export const StyledKeyFeaturesSections = styled.div(
  ({ theme }) => `
      display: flex;
      flex-direction: column;
      gap: ${theme.size[DesignTokenSizeEnum.static370]};
  
      ${convertBreakpointsToMediaQueries({
        b960: {
          gap: theme.size[DesignTokenSizeEnum.static530],
        },
      })}
      `
);
